import { render, staticRenderFns } from "./AllAssetList.vue?vue&type=template&id=56c04090&"
import script from "./AllAssetList.vue?vue&type=script&lang=js&"
export * from "./AllAssetList.vue?vue&type=script&lang=js&"
import style0 from "./AllAssetList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports